import React from 'react'
import { useState } from "react"
import { Filter, PlusIcon } from "lucide-react"

export default function HighlightsHeader() {
  const [viewBy, setViewBy] = useState("Time")
  const [dropdownOpen, setDropdownOpen] = useState(false)

  const toggleDropdown = () => setDropdownOpen(!dropdownOpen)

  const selectViewBy = (option) => {
    setViewBy(option)
    setDropdownOpen(false)
  }

  return (
    <h2 className="flex items-center justify-between bg-[#212121] text-white p-1" style={{marginRight: "-1px"}}>
      <span className="pl-0 text-xs">Highlights</span>

      <ul className="flex space-x-2">
        <li>
          <div className="flex items-center">
            <input type="checkbox" id="checkboxLive" className="sr-only peer" />
            <label
              htmlFor="checkboxLive"
              className="cursor-pointer relative flex items-center justify-center px-3 py-1 text-[10px] font-medium rounded-full border border-gray-300 peer-checked:bg-yellow-100  peer-checked:text-black peer-checked:border-yellow "
            >
              <PlusIcon size={12} className='mr-1'/>
              LIVE
            </label>
          </div>
        </li>
        <li>
          <div className="flex items-center">
            <input type="checkbox" id="checkboxVirtual" className="sr-only peer" />
            <label
              htmlFor="checkboxVirtual"
              className="cursor-pointer relative flex items-center justify-center px-3 py-1 text-[10px] font-medium rounded-full border border-gray-300 peer-checked:bg-yellow-100  peer-checked:text-black peer-checked:border-yellow "
            >
                            <PlusIcon size={12} className='mr-1'/>

              VIRTUAL
            </label>
          </div>
        </li>
      </ul>

      
    </h2>
  )
}

